import { CheckboxStyled } from '../CheckboxStyled';
import styled from '../../../styles/theme';

export const CheckboxStyledFRDS = styled(CheckboxStyled)`
    .container label {
        color: ${({ theme }) => theme.colors.black};
    }

    .container input + label::before {
        border-color: ${({ theme }) => theme.colors.primary};
    }
`;
